import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSassComponent } from './simple-icons-sass.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSassComponent ],
    exports:      [ SimpleIconsSassComponent ],
    bootstrap:    []
})
export class SimpleIconsSassModule {}
